import { AxiosInstance } from "axios";
import {
  Configuration,
  MobileAppVersionDto,
} from "../../../common/data/service-proxies";
import { ICrudApiProxy } from "../../../common/data/types";

interface CreateMobileAppVersion extends Partial<MobileAppVersionDto> {
  mobileApplicationTypeString: string;
  file: any;
}

export const MobileAppVersionApiFactoryAdapter = (
  configuration: Configuration | undefined,
  baseURL: string,
  axiosInstance: AxiosInstance
) => ({
  get: function (target: ICrudApiProxy, prop: string) {
    return prop === "apiAppMobileappversionPost"
      ? this.apiAppMobileappversionPost
      : target[prop];
  },

  apiAppMobileappversionPost: (data: CreateMobileAppVersion, options?: any) => {
    const formData = new FormData();
    formData.append("File", data.file.rawFile);
    formData.append(
      "MobileApplicationTypeString",
      data.mobileApplicationTypeString
    );
    formData.append("AppVersion", data.appVersion!);
    formData.append("BuildNumber", `${data.buildNumber}`);
    return axiosInstance.post(baseURL + `/api/app/mobileAppVersion`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...options,
    });
  },
});
